export const TOGGLE_FOCUSED_CAMERA_SELECTOR_EVENT = 'toggle-focused-camera-selector';
export const CAMERA_SELECTOR_NAVIGATE_EVENT = 'camera-selector-navigate';
export const CAMERA_SELECTOR_CONFIRM_EVENT = 'camera-selector-confirm';
